import axios from 'axios';
import Router from 'next/router';
import EmailPasswordWebJs from 'supertokens-web-js/recipe/emailpassword';
import EmailVerificationWebJS from 'supertokens-web-js/recipe/emailverification';
import MultiFactorAuth from 'supertokens-web-js/recipe/multifactorauth';
import Session from 'supertokens-web-js/recipe/session';
import Totp from 'supertokens-web-js/recipe/totp';
import { appInfo } from './appInfo';

const apiDomain =
  process.env.NODE_ENV !== 'development'
    ? process.env.NEXT_PUBLIC_API_DOMAIN
    : 'http://localhost:3001';

const client = axios.create({
  baseURL: apiDomain,
});

const syncToken = async () => {
  try {
    await client.get('/get-synced-token');
    await Session.getAccessToken();
    return true;
  } catch (err) {
    console.error('Token sync failed:', err);
    return false;
  }
};

export const frontendConfig = () => {
  return {
    appInfo,
    recipeList: [
      EmailPasswordWebJs.init(),
      EmailVerificationWebJS.init(),
      Session.init({
        tokenTransferMethod: 'header',
        onHandleEvent: async (event) => {
          if (event.action === 'ACCESS_TOKEN_PAYLOAD_UPDATED') {
            await syncToken();
          }
        },
      }),
      Totp.init(),
      MultiFactorAuth.init(),
    ],
    windowHandler: (oI: any) => {
      return {
        ...oI,
        location: {
          ...oI.location,
          setHref: (href: any) => {
            Router.push(href);
          },
        },
      };
    },
  };
};
